import React, { Component } from 'react';

import {emojiUrlForRating} from '../../utils';

class EnjoyabilityDial extends Component {
  constructor(props){
    super(props);

    this.state = {};
  }

  getDialNeedlePath(){
    const { width, dialWidth, iconRadius, iconPadding, needlePadding, rating } = this.props,
      radius = (width/2) - (dialWidth + iconRadius * 2 + 2 * iconPadding + needlePadding),
      baseWidth = 6,
      needleBaseX = (width/2),
      needleBaseY = (width/2) - baseWidth,
      angle = ((4 - rating) / 4) * Math.PI,
      needlePointX = Math.cos(angle) * radius + (width/2),
      needlePointy = (width/2) - Math.sin(angle) * radius,
      needleBaseRightX = needleBaseX + Math.cos(angle + Math.PI/2)*(baseWidth / 2),
      needleBaseRightY = needleBaseY - Math.sin(angle + Math.PI/2)*(baseWidth / 2),
      needleBaseLeftX = needleBaseX + Math.cos(angle - Math.PI/2)*(baseWidth / 2),
      needleBaseLeftY = needleBaseY - Math.sin(angle - Math.PI/2)*(baseWidth / 2);

    return `
      M${needleBaseRightX} ${needleBaseRightY}
      L${needlePointX} ${needlePointy}
      L${needleBaseLeftX} ${needleBaseLeftY}
      A ${baseWidth/2} ${baseWidth/2} 0 0 1 ${needleBaseRightX} ${needleBaseRightY}
    `;
  }

  getIconRadiusForRating(rating){
    if(!this.props.rating && this.props.rating !== 0){
      return this.props.iconRadius;
    } else if(this.ratingInBounds(rating)){
      return this.props.iconRadius + 5;
    } else {
      return this.props.iconRadius
    }
  }

  ratingInBounds(rating){
    return Math.floor(this.props.rating + 0.5) === rating;
  }

  renderIcons(){
    const width = this.props.width,
      iconWidth = this.props.iconRadius * 2,
      iconHeight = this.props.iconRadius * 2;

    return (
      <g>
        <image
          x='0'
          y={width / 2 - (iconHeight + this.ratingInBounds(0) ? iconHeight + 10 : 0)}
          width={this.getIconRadiusForRating(0) * 2}
          height={this.getIconRadiusForRating(0) * 2}
          xlinkHref={emojiUrlForRating(0)}
        />
        <image
          x={(width / 2 - iconWidth/2) - (width/2 - iconWidth/2) / Math.sqrt(2)}
          y={(width / 2 - iconWidth/2) - (width/2 - iconWidth/2) / Math.sqrt(2)}
          width={this.getIconRadiusForRating(1) * 2}
          height={this.getIconRadiusForRating(1) * 2}
          xlinkHref={emojiUrlForRating(1)}
        />
        <image
          x={width / 2 - iconWidth / 2}
          y='0'
          width={this.getIconRadiusForRating(2) * 2}
          height={this.getIconRadiusForRating(2) * 2}
          xlinkHref={emojiUrlForRating(2)}
        />
        <image
          x={width / 2 + (Math.cos(Math.PI / 4) * (width / 2 - iconWidth / 2)) - iconWidth/2}
          y={width / 2 - (Math.sin(Math.PI / 4) * (width / 2 - iconHeight / 2)) - iconWidth/2}
          width={this.getIconRadiusForRating(3) * 2}
          height={this.getIconRadiusForRating(3) * 2}
          xlinkHref={emojiUrlForRating(3)}
        />
        <image
          x={width - (iconWidth + this.ratingInBounds(0) ? iconWidth + 10 : 0)}
          y={width / 2 - (iconHeight + this.ratingInBounds(0) ? iconHeight + 10 : 0)}
          width={this.getIconRadiusForRating(4) * 2}
          height={this.getIconRadiusForRating(4) * 2}
          xlinkHref={emojiUrlForRating(4)}
        />
      </g>
    );
  }

  renderDialSection(index,color){
    const angleStart = (4.5 - index) / 4 * Math.PI,
      angleFinish = (4.5 - (index + 1)) / 4 * Math.PI,
      outerRadius = this.props.width / 2 - 50,
      innerRadius = this.props.width / 2 - (50 + this.props.dialWidth),
      arcWidth = (outerRadius - innerRadius) / 2,
      xOffset = (this.props.iconRadius * 2) + 20,
      yOffset = (this.props.iconRadius * 2) + 20;

    const path = `
      M
        ${(outerRadius+xOffset) + Math.cos(angleStart)*innerRadius}
        ${(outerRadius+yOffset) - Math.sin(angleStart)*innerRadius}
      A
        ${innerRadius},${innerRadius} 0 0, 1
        ${(outerRadius+xOffset) + Math.cos(angleFinish)*innerRadius}
        ${(outerRadius+yOffset) - Math.sin(angleFinish)*innerRadius}
      A
        ${arcWidth},${arcWidth} 0 0, 0
        ${(outerRadius+xOffset) + Math.cos(angleFinish)*outerRadius}
        ${(outerRadius+yOffset) - Math.sin(angleFinish)*outerRadius}
      A
        ${outerRadius},${outerRadius} 0 0, 0
        ${(outerRadius+xOffset) + Math.cos(angleStart)*outerRadius}
        ${(outerRadius+yOffset) - Math.sin(angleStart)*outerRadius}
      A
        ${arcWidth},${arcWidth} 0 0, 1
        ${(outerRadius+xOffset) + Math.cos(angleStart)*innerRadius}
        ${(outerRadius+yOffset) - Math.sin(angleStart)*innerRadius}
      Z
    `;

    return (
      <path
        stroke={color}
        fill={color}
        d={path}
      />
    );
  }

  render(){
    return (
      <svg
        className='AdjoyabilityDial'
        height={this.props.width/2}
        width={this.props.width}
      >
        {this.renderIcons()}
        {this.renderDialSection(0,'#b50909')}
        {this.renderDialSection(1,'#ff5728')}
        {this.renderDialSection(2,'#fede27')}
        {this.renderDialSection(3,'#47b834')}
        {this.renderDialSection(4,'#138401')}
        {this.props.rating && (
          <path
            d={this.getDialNeedlePath()}
            stroke='#575757'
            fill='#575757'
            strokeWidth='1'
          />
        )}
        {!this.props.rating && (
          <text
            x={this.props.width/2 - 10}
            y={this.props.width/2 - 5}
            style={{
              fontSize:60
            }}
            fill='#575757'
          >
            ?
          </text>
        )}
      </svg>
    );
  }
}

EnjoyabilityDial.defaultProps = {
  width:400,
  iconRadius:15,
  iconPadding:10,
  needlePadding:10,
  dialWidth:7
};


export default EnjoyabilityDial;



// WEBPACK FOOTER //
// ./src/shared/components/AdjoyabilityDial/index.js